import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { TOfferingsIconSizes } from './models/icon'

export const DEFAULT_OFFERING_ICON_SIZES: TOfferingsIconSizes = {
  [ProgramTypes.CorePrint]: {
    width: 48,
    height: 48,
  },
  [ProgramTypes.Print]: {
    width: 48,
    height: 48,
  },
  [ProgramTypes.Printing3D]: {
    width: 38,
    height: 34,
  },
  [ProgramTypes.LargeFormat]: {
    width: 48,
    height: 48,
  },
  [ProgramTypes.PersonalSystems]: {
    width: 48,
    height: 48,
  },
  [ProgramTypes.PC]: {
    width: 48,
    height: 48,
  },
  [ProgramTypes.Supplies]: {
    width: 36,
    height: 33,
  },
}
